import {SET_PAGE} from "app/actions/page";

export default function page({action, state = null}) {
  switch(action.type) {
    case SET_PAGE: {
      const data = action.payload;

      return {...data};
    }
    default:
      return state;
  }
}
